import React from 'react'
import classes from './StudentForm.module.css'
import { useNavigate } from 'react-router-dom'
import StudentForm from '../../containers/Dashboard/components/Pages/Student/component/StudentForm'
import { horizontalLogo } from '../../assets/images'
import { StudentSucess } from '../../containers/Dashboard/components/Pages/Student/component/StudentSuccess'
import { ToastContainer } from 'react-toastify'
import { useSelector } from 'react-redux'
import { CircularProgress } from '@mui/material'

const StudentFormPage = () => {
  const { loader, openImport, inExpense, creditOpen } = useSelector((state) => state.global)

  const userSchoolId = localStorage.getItem('userSchoolId')
  const storedAttributes = localStorage.getItem('userAttributes')
  const attributes = JSON.parse(storedAttributes)
  const customRole = attributes?.employee_type
  //   const [addManual, setAddManual] = useState(false)
  const [success, setsuccess] = React.useState(false)
  const navigate = useNavigate()

  const handleFormClose = () => {
    navigate('/dashboard')
  }
  if (success) {
    return (
      <div className={classes.sucessbox}>
        <StudentSucess success={success} setSuccess={setsuccess} />
      </div>
    )
  }
  return (
    <>
      <ToastContainer />
      {loader && (
        <div className="circular-box" style={{ height: inExpense ? '100dvh' : '100dvh' }}>
          <CircularProgress />
        </div>
      )}
      <div className={classes.container}>
        <img src={horizontalLogo} alt="" className={classes.logo} />
        <div className={classes.box}>
          <StudentForm
            success={success}
            setSuccess={setsuccess}
            handleClose={handleFormClose}
            customRole={customRole}
            userSchoolId={userSchoolId}
          />
        </div>
      </div>
    </>
  )
}

export default StudentFormPage
